const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api/v1";

const apiRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem("authToken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    ...options,
  };

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    const data = await response.json();

    if (response.status === 401) {
      // Token expired or invalid — clear session and reload to show login screen
      localStorage.removeItem("user");
      localStorage.removeItem("authToken");
      window.location.reload();
      return;
    }

    if (!response.ok) {
      throw new Error(data.message || "API request failed");
    }

    return data;
  } catch (error) {
    console.error("API request error:", error);
    throw error;
  }
};

// Auth API
export const authAPI = {
  login: async (email, password) => {
    return apiRequest("/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
  },

  setupTotp: async (tempToken, totpCode) => {
    return apiRequest("/setup-totp", {
      method: "POST",
      body: JSON.stringify({ temp_token: tempToken, totp_code: totpCode }),
    });
  },

  verifyTotp: async (tempToken, totpCode) => {
    return apiRequest("/verify-totp", {
      method: "POST",
      body: JSON.stringify({ temp_token: tempToken, totp_code: totpCode }),
    });
  },
};

export const requestsAPI = {
  getRequests: async () => {
    const response = await apiRequest("/fund-requests");
    return {
      summary: response.summary,
      requests: response.requests,
    };
  },

  getRequestDetails: async (eventId) => {
    const response = await apiRequest(`/events/${eventId}/details`);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || 'Failed to fetch event details');
  },

  getDetailsByFundRequestId: async (eventId) => {
    const response = await apiRequest(`/fund-requests/${eventId}/details`);
    if (response.success) {
      return response.data;
    }
    throw new Error(response.message || 'Failed to fetch details');
  },
};
